import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconMeeting = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconMeeting.dimensions.width} ${IconMeeting.dimensions.height}`}
      {...otherProps}
    >
      <G fill={color || Color.premiumBlack} fillRule="nonzero">
        <Path d="M4.855 0a2.885 2.885 0 110 5.77 2.885 2.885 0 010-5.77zm0 1.33a1.555 1.555 0 100 3.11 1.555 1.555 0 000-3.11zM12.365 0a2.885 2.885 0 110 5.77 2.885 2.885 0 010-5.77zm0 1.33a1.555 1.555 0 100 3.11 1.555 1.555 0 000-3.11zM19.865 0a2.885 2.885 0 110 5.77 2.885 2.885 0 010-5.77zm0 1.33a1.555 1.555 0 100 3.11 1.555 1.555 0 000-3.11zM4.855 13.92a2.885 2.885 0 110 5.77 2.885 2.885 0 010-5.77zm0 1.33a1.555 1.555 0 100 3.11 1.555 1.555 0 000-3.11zM12.365 13.92a2.885 2.885 0 110 5.77 2.885 2.885 0 010-5.77zm0 1.33a1.555 1.555 0 100 3.11 1.555 1.555 0 000-3.11zM19.865 13.92a2.885 2.885 0 110 5.77 2.885 2.885 0 010-5.77zm0 1.33a1.555 1.555 0 100 3.11 1.555 1.555 0 000-3.11z" />
        <Path d="M5.52 14.585v-1.28a.665.665 0 10-1.33 0v1.28a.665.665 0 101.33 0zM13.03 14.585v-1.28a.665.665 0 10-1.33 0v1.28a.665.665 0 101.33 0zM20.53 14.585v-1.28a.665.665 0 10-1.33 0v1.28a.665.665 0 101.33 0zM5.52 6.375v-1.28a.665.665 0 10-1.33 0v1.28a.665.665 0 101.33 0zM13.03 6.375v-1.28a.665.665 0 10-1.33 0v1.28a.665.665 0 101.33 0zM20.53 6.375v-1.28a.665.665 0 10-1.33 0v1.28a.665.665 0 101.33 0zM2.786 15.953a3.299 3.299 0 01-1.456-2.721V6.835c0-1.17.624-2.25 1.637-2.834a.665.665 0 00-.664-1.152A4.603 4.603 0 000 6.835v6.4a4.63 4.63 0 002.044 3.822.665.665 0 00.742-1.104zM10.145 16.52h-2.84a.665.665 0 100 1.33h2.84a.665.665 0 100-1.33zM17.525 16.52h-2.98a.665.665 0 100 1.33h2.98a.665.665 0 100-1.33zM21.88 4.081a3.293 3.293 0 011.49 2.754v6.4a3.261 3.261 0 01-1.454 2.716.665.665 0 10.738 1.108 4.591 4.591 0 002.046-3.824v-6.4a4.623 4.623 0 00-2.09-3.866.665.665 0 10-.73 1.112zM14.575 3.55h3.08a.665.665 0 100-1.33h-3.08a.665.665 0 100 1.33zM7.065 3.55h3.08a.665.665 0 100-1.33h-3.08a.665.665 0 100 1.33z" />
      </G>
    </Svg>
  )
}

IconMeeting.dimensions = {
  width: 25,
  height: 20,
}

export default IconMeeting
